module.exports = __webpack_public_path__ + "img/BRAVO_8.0442f295.jpg";